import { SVGObject } from "../svgobject";

export class SVGArchitecture5 extends SVGObject{
    public drawObject():void{
		super.initObject();
        this.svg =`<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20000303 Stylable//EN" "http://www.w3.org/TR/2000/03/WD-SVG-20000303/DTD/svg-20000303-stylable.dtd"[]><svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 522 999"><path style="fill:#3f4c4c;stroke:#4c4c4c;stroke-width:2" d="M0,0 l522,0 0,999 -522,0 0,-999z" /><path style="fill:#98b2b2;stroke:#4c4c4c;stroke-width:2" d="M42,42 l480,0 0,957 -480,0 0,-957z" /><circle style="fill:#8c8c8c;stroke:#4c4c4c;stroke-width:2" cx="436" cy="519" r="41" /><circle style="fill:#ccc" cx="432" cy="515" r="29" /><circle style="fill:#fff" cx="426" cy="509" r="10" /></svg>`
		super.fillGradients();
        super.drawObject();
    }
}